import { render, staticRenderFns } from "./IconStatusClosed.vue?vue&type=template&id=1ec6a525&"
import script from "./IconStatusClosed.vue?vue&type=script&lang=ts&"
export * from "./IconStatusClosed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports